<script lang="ts">
  import type {MatrixQuestion, CurrentResponses, QuestionOnChange} from '../types';
  import Markdown from '../Markdown.svelte';
  import {getDisplayValue} from '../utils';
  export let question: MatrixQuestion;
  export let pageQuestionIdx: string;
  export let onChange: QuestionOnChange;
  export let currentResponses: CurrentResponses;

  $: label = getDisplayValue<MatrixQuestion>(currentResponses, question, 'label') as string;
  $: rows = getDisplayValue<MatrixQuestion>(currentResponses, question, 'rows') as string[];
  $: columns = getDisplayValue<MatrixQuestion>(currentResponses, question, 'columns') as string[];
</script>

<div class="flex flex-wrap items-center overflow-x-scroll md:overflow-x-visible w-full md:justify-center">
  <table>
    <thead>
      <tr>
        {#each [' ', ...columns] as col}
          <th class=""><div class="header"><Markdown text={col} /></div></th>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each rows as row}
        <tr>
          <td><Markdown text={row} /></td>
          {#each columns as col, idx}
            <td>
              <div
                class="flex items-center justify-center relative w-full border-2 border-white dark:border-zinc-900 rounded hover:border-sky-400  cursor-pointer"
              >
                <label
                  for={`option-${pageQuestionIdx}-${idx}-${row}`}
                  class="absolute w-full h-full cursor-pointer"
                />
                <input
                  type="radio"
                  name={`${label}-${row}`}
                  id={`option-${pageQuestionIdx}-${idx}-${row}`}
                  on:change={() => onChange({newValue: col, altId: `${pageQuestionIdx}-${row}`})}
                  checked={currentResponses[`${pageQuestionIdx}-${row}`] === col}
                  class="cursor-pointer"
                />
              </div>
            </td>
          {/each}
        </tr>
      {/each}
    </tbody>
  </table>
</div>

<style>
  th > div {
    width: 65px;
  }
  td > div {
    height: 20px;
  }
</style>
